import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { putRequest } from 'services/apiRequests';
import type { StringifiedUUID } from 'types';
import { DataObject, DataObjectUpdateRequest } from 'types/dataObject';
import { APIError } from 'utils/errors';

const apiUrl = (modelId: StringifiedUUID, objectId: StringifiedUUID) =>
  `/api/v1/tq/hierarchy-models/${modelId}/objects/${objectId}/`;

const updateDataObject =
  (modelId: StringifiedUUID, objectId: StringifiedUUID, csrfToken: string) => (dataObj: DataObjectUpdateRequest) => {
    return putRequest<DataObjectUpdateRequest, DataObject>(apiUrl(modelId, objectId), dataObj, csrfToken);
  };

const useCreateDataObjectMutation = (
  modelId: StringifiedUUID,
  objectId: StringifiedUUID,
  csrfToken: string,
  options: UseMutationOptions<DataObject, APIError, DataObjectUpdateRequest> = {},
) => {
  const queryClient = useQueryClient();

  return {
    mutation: useMutation<DataObject, APIError, DataObjectUpdateRequest>({
      ...options,
      onSuccess: (data, variables, context, mutationContext) => {
        queryClient.invalidateQueries({ queryKey: ['tqModelTree'] });
        options.onSuccess?.(data, variables, context, mutationContext);
      },
      mutationFn: updateDataObject(modelId, objectId, csrfToken),
    }),
  };
};

export const DataObjectsService = {
  useCreateDataObjectMutation,
};
